import { Injectable } from '@angular/core';
import { OutageBannerContentSelectors } from '@core/store/selectors';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { OutageBannerContentActions } from '@core/store/actions';
import { OutageBannerContent } from './outage-banner-content.reducer';

@Injectable({
  providedIn: 'root',
})
export class OutageBannerContentService {
  constructor(private store: Store) {}

  getOutageMessage(): Observable<string> {
    return this.store.select(OutageBannerContentSelectors.getOutageMessage);
  }

  storeOutageBannerContent(payload: OutageBannerContent): void {
    this.store.dispatch(
      OutageBannerContentActions.storeOutageBannerContent({ payload })
    );
  }
}
